"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _EV33XSIBcjs = require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _MPIQVHCBcjs = require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/combobox/combobox-cancel.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "button";
var children = /* @__PURE__ */ _jsxruntime.jsxs.call(void 0, 
  "svg",
  {
    "aria-hidden": "true",
    display: "block",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    width: "1em",
    height: "1em",
    pointerEvents: "none",
    children: [
      /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "line", { x1: "5", y1: "5", x2: "11", y2: "11" }),
      /* @__PURE__ */ _jsxruntime.jsx.call(void 0, "line", { x1: "5", y1: "11", x2: "11", y2: "5" })
    ]
  }
);
var useComboboxCancel = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useComboboxCancel2({ store, hideWhenEmpty, ...props }) {
    const context = _EV33XSIBcjs.useComboboxProviderContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "ComboboxCancel must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const onClickProp = props.onClick;
    const onClick = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      store == null ? void 0 : store.setValue("");
      store == null ? void 0 : store.move(null);
    });
    const comboboxId = _FH6HQ5JNcjs.useStoreState.call(void 0, store, (state) => {
      var _a;
      return (_a = state.baseElement) == null ? void 0 : _a.id;
    });
    const empty = _FH6HQ5JNcjs.useStoreState.call(void 0, store, (state) => state.value === "");
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => {
        if (!hideWhenEmpty) return element;
        if (empty) return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _react.Fragment, {});
        return element;
      },
      [hideWhenEmpty, empty]
    );
    props = {
      children,
      "aria-label": "Clear input",
      // This aria-controls will ensure the combobox popup remains visible when
      // this element gets focused. This logic is done in the ComboboxPopover
      // component.
      "aria-controls": comboboxId,
      ...props,
      onClick
    };
    props = _MPIQVHCBcjs.useButton.call(void 0, props);
    return props;
  }
);
var ComboboxCancel = _PTOCUU2Dcjs.forwardRef.call(void 0, function ComboboxCancel2(props) {
  const htmlProps = useComboboxCancel(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.ComboboxCancel = ComboboxCancel; exports.useComboboxCancel = useComboboxCancel;
